<script>

	import VitrineItem from "../components/VitrineItem.svelte";  

	let vitrineId               = 'vitrine-' +  Math.random(0, 100).toString().substr(2);
	
	export let vitrineHeight    = '55vh';
	export let vitrineStyle     = '';
	export let vitrines         = [];
	export let settings        	= {arrows:true};
	export let showDots			= true;

	jQuery(document).ready(()=>{
		jQuery('.' + vitrineId).slick({
			infinite: true,
			speed: 450,
			slidesToShow: 1,
			autoplay: true,
			arrows: true,
			dots: showDots,
			...settings
		});

		jQuery('.' + vitrineId).show();
	});
</script> 

<div class="vitrine vitrine--{vitrineStyle} {vitrineId}" style="display: none;">
	{#each vitrines as vitrine}
		<VitrineItem height="{vitrineHeight}" {...vitrine} />
	{/each}
</div>